import React, { useEffect, useState } from "react";
import Card from "./Card";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import axios from "axios";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";


const NewArrival = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const breakpoints = {
    300: {
      slidesPerView: 1,
    },
    350: {
      slidesPerView: 1.1,
    },
    400: {
      slidesPerView: 1.27,
    },
    550: {
      slidesPerView: 2,
    },
    770: {
      slidesPerView: 3,
    },
    1000: {
      slidesPerView: 3.5,
    },
    1400: {
      slidesPerView: 4,
    },
    1600: {
      slidesPerView: 4.5,
    },
  };

  useEffect(() => {
    const FetchProducts = async () => {
      try {
        setLoading(true)
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/products/getproducts?limit=15`,
          {
            headers: {
              "Content-Type": "application/json",
              token: Cookies.get("token"),
            },
          }
        );

        const cleaned = res.data
          .map(item => ({
            id: item._id,
            sku: item.sku,
            brand: item.Brand,
            description: item.Description,
            image: item.ProductimageURL,
            Category:item.Category,
            price: item.finalPrice|| "", // use optional
          }));

        setProducts(cleaned);

        setLoading(false)
      } catch (err) {
        console.log(err);
      }
    };

    FetchProducts();
  }, []);

  if (loading) return "LOADING..."

  return (
    <div className="NewArrival mt-5">
      <div className="section-head w-75 mx-auto text-center">
        <h1 className="fw-bold">Últimos Modelos</h1>
        <p className="text-muted mt-2">
          Mira los últimos lanzamientos y las ofertas que tenemos para ti.
        </p>
      </div>
      <div className="d-flex justify-content-between canvas mt-4">
        <Swiper
          spaceBetween={15}
          breakpoints={breakpoints}
          navigation={true}
          modules={[Navigation]}
          className="w-100"
        >
          {products?.map((elem) => {
            return (
              <SwiperSlide key={elem.CodeCN}>
                <Card
                  product={elem}
                />

              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>

      <div className="w-100 d-flex justify-content-center mt-5">
        <Link to={"/products"} className="btn text-white bg_primary py-2 px-4 fs-5">View More</Link>
      </div>
    </div>
  );
};

export default NewArrival;
